module.exports = __webpack_public_path__ + "img/symbol_6.df1a0621.png";